module.exports = __webpack_public_path__ + "img/symbol_0.c51d6e9b.png";